import type { Alert } from "./alert.model";
import { GenericAlertTypeEnum } from "./genericAlertType.enum";
import type { GeofenceViolationAlert } from "./geofenceViolationAlert.model";
import type { LossOfAdherenceAlert } from "./lossOfAdherenceAlert.model";
import type { LossOfSeparationAlert } from "./lossOfSeparationAlert.model";
import type { NoSignalAlert } from "./noSignalAlert.model";
import type { PotentialGeofenceViolationAlert } from "./potentialGeofenceViolationAlert.model";
import type { PotentialLossOfSeparationAlert } from "./potentialLossOfSeparationAlert.model";
import type { RecordUpdate } from "./recordUpdate.model";
import type { StatusAlert } from "./statusAlert.model";

export namespace GenericAlertTypeNamespace {
    export function toInteger(t: GenericAlertTypeEnum): number {
        switch(t) {
            case GenericAlertTypeEnum.ALERT_UNKNOWN:
                return 0;
            case GenericAlertTypeEnum.ALERT_NOSIGNAL:
                return 1;
            case GenericAlertTypeEnum.ALERT_LOSS_ADHERENCE:
                return 2;
            case GenericAlertTypeEnum.ALERT_LOSS_SEPARATION:
                return 3;
            case GenericAlertTypeEnum.ALERT_GEOFENCE:
                return 4;
            case GenericAlertTypeEnum.ALERT_POTENTIAL_LOSS_SEPARATION:
                return 5;
            case GenericAlertTypeEnum.ALERT_POTENTIAL_GEOFENCE:
                return 6;
            case GenericAlertTypeEnum.ALERT_STATUS:
                return 7;
        }
    }

    export function fromInteger(x: number): GenericAlertTypeEnum {
        switch(x) {
            case 0:
                return GenericAlertTypeEnum.ALERT_UNKNOWN;
            case 1:
                return GenericAlertTypeEnum.ALERT_NOSIGNAL;
            case 2:
                return GenericAlertTypeEnum.ALERT_LOSS_ADHERENCE;
            case 3:
                return GenericAlertTypeEnum.ALERT_LOSS_SEPARATION;
            case 4:
                return GenericAlertTypeEnum.ALERT_GEOFENCE;
            case 5:
                return GenericAlertTypeEnum.ALERT_POTENTIAL_LOSS_SEPARATION;
            case 6:
                return GenericAlertTypeEnum.ALERT_POTENTIAL_GEOFENCE;
            case 7:
                return GenericAlertTypeEnum.ALERT_STATUS;
        }
        return GenericAlertTypeEnum.ALERT_UNKNOWN;
    }

    export function getAlertTypeString(alertType: GenericAlertTypeEnum): string {
        switch (alertType) {
            case GenericAlertTypeEnum.ALERT_NOSIGNAL:
                return 'ALERT_NOSIGNAL';
            case GenericAlertTypeEnum.ALERT_LOSS_ADHERENCE:
                return 'ALERT_LOSS_ADHERENCE';
            case GenericAlertTypeEnum.ALERT_LOSS_SEPARATION:
                return 'ALERT_LOSS_SEPARATION';
            case GenericAlertTypeEnum.ALERT_GEOFENCE:
                return 'ALERT_GEOFENCE';
            case GenericAlertTypeEnum.ALERT_POTENTIAL_LOSS_SEPARATION:
                return 'ALERT_POTENTIAL_LOSS_SEPARATION';
            case GenericAlertTypeEnum.ALERT_POTENTIAL_GEOFENCE:
                return 'ALERT_POTENTIAL_GEOFENCE';
            case GenericAlertTypeEnum.ALERT_STATUS:
                return 'ALERT_STATUS';
            default:
                return 'ALERT_UNKNOWN';
        }
    }

    export function toNiceString(t: GenericAlertTypeEnum): string {
        switch(t) {
            case GenericAlertTypeEnum.ALERT_UNKNOWN:
                return "Unknown Alert";
            case GenericAlertTypeEnum.ALERT_NOSIGNAL:
                return "No Signal Alert";
            case GenericAlertTypeEnum.ALERT_LOSS_ADHERENCE:
                return "Loss of Adherence Alert";
            case GenericAlertTypeEnum.ALERT_LOSS_SEPARATION:
                return "Loss of Separation Alert";
            case GenericAlertTypeEnum.ALERT_GEOFENCE:
                return "Geofence Violation Alert";
            case GenericAlertTypeEnum.ALERT_POTENTIAL_LOSS_SEPARATION:
                return "Potential Loss of Separation";
            case GenericAlertTypeEnum.ALERT_POTENTIAL_GEOFENCE:
                return "Potential Geofence Violation Alert";
            case GenericAlertTypeEnum.ALERT_STATUS:
                return "Status Alert";
        }
    }

    export function fromString(alertTypeString: string): GenericAlertTypeEnum {
        switch (alertTypeString) {
            case 'ALERT_UNKNOWN':
                return GenericAlertTypeEnum.ALERT_UNKNOWN;
            case 'ALERT_NOSIGNAL':
                return GenericAlertTypeEnum.ALERT_NOSIGNAL;
            case 'ALERT_LOSS_ADHERENCE':
                return GenericAlertTypeEnum.ALERT_LOSS_ADHERENCE;
            case 'ALERT_LOSS_SEPARATION':
                return GenericAlertTypeEnum.ALERT_LOSS_SEPARATION;
            case 'ALERT_GEOFENCE':
                return GenericAlertTypeEnum.ALERT_GEOFENCE;
            case 'ALERT_POTENTIAL_LOSS_SEPARATION':
                return GenericAlertTypeEnum.ALERT_POTENTIAL_LOSS_SEPARATION;
            case 'ALERT_POTENTIAL_GEOFENCE':
                return GenericAlertTypeEnum.ALERT_POTENTIAL_GEOFENCE;
            case 'ALERT_STATUS':
                return GenericAlertTypeEnum.ALERT_STATUS;
            default:
                return GenericAlertTypeEnum.ALERT_UNKNOWN; // Valor predeterminado si no coincide
        }
    }
}

export function createAlert(vehicle: string, alertValueJSON: string): 
    NoSignalAlert | 
    LossOfAdherenceAlert | 
    LossOfSeparationAlert | 
    GeofenceViolationAlert | 
    PotentialLossOfSeparationAlert |
    PotentialGeofenceViolationAlert |
    StatusAlert |
    null {

    let generalAlert: Alert = JSON.parse(alertValueJSON);
    
    switch(GenericAlertTypeNamespace.fromString(generalAlert.alertType)) {
        case GenericAlertTypeEnum.ALERT_NOSIGNAL:

            const noSignalAlert: NoSignalAlert = JSON.parse(alertValueJSON);
            noSignalAlert.vehiclePlate = vehicle;
            noSignalAlert.created = new Date().toUTCString();
            return noSignalAlert;

        case GenericAlertTypeEnum.ALERT_LOSS_ADHERENCE:
            
            const lossOfAdherenceAlert: LossOfAdherenceAlert = JSON.parse(alertValueJSON);
            lossOfAdherenceAlert.vehiclePlate = vehicle;
            let records: RecordUpdate[] = [];
            if (lossOfAdherenceAlert.recordsUpdates) {
                lossOfAdherenceAlert.recordsUpdates.forEach((recordUpdate: any) => {
                    const record: RecordUpdate = JSON.parse(recordUpdate);
                    records.push(record);
                });
                lossOfAdherenceAlert.recordsUpdates = records;
            }
            lossOfAdherenceAlert.created = new Date().toUTCString();
            return lossOfAdherenceAlert;

        case GenericAlertTypeEnum.ALERT_LOSS_SEPARATION:
            
            const lossOfSeparationAlert: LossOfSeparationAlert = JSON.parse(alertValueJSON);
            lossOfSeparationAlert.vehiclePlate = vehicle;
            lossOfSeparationAlert.created = new Date().toUTCString();
            return lossOfSeparationAlert;
        
        case GenericAlertTypeEnum.ALERT_GEOFENCE:
            
            const geofenceViolationAlert: GeofenceViolationAlert = JSON.parse(alertValueJSON);
            geofenceViolationAlert.vehiclePlate = vehicle;
            geofenceViolationAlert.created = new Date().toUTCString();
            return geofenceViolationAlert;
        
        case GenericAlertTypeEnum.ALERT_POTENTIAL_LOSS_SEPARATION:
            
            const potentialLossOfSeparationAlert: PotentialLossOfSeparationAlert = JSON.parse(alertValueJSON);
            potentialLossOfSeparationAlert.vehiclePlate = vehicle;
            potentialLossOfSeparationAlert.created = new Date().toUTCString();
            return potentialLossOfSeparationAlert;

        case GenericAlertTypeEnum.ALERT_POTENTIAL_GEOFENCE:
            
            const potentialGeofenceViolationAlert: PotentialGeofenceViolationAlert = JSON.parse(alertValueJSON);
            potentialGeofenceViolationAlert.vehiclePlate = vehicle;
            potentialGeofenceViolationAlert.created = new Date().toUTCString();
            return potentialGeofenceViolationAlert;
        
        case GenericAlertTypeEnum.ALERT_STATUS:
            
            const statusAlert: StatusAlert = JSON.parse(alertValueJSON);
            statusAlert.vehiclePlate = vehicle;
            statusAlert.created = new Date().toUTCString();
            return statusAlert;
        
        default:
            return null;
    }
}